import { Component, computed, input } from '@angular/core';
import { ClassValue } from 'clsx';
import { bui } from '../utils/bui';

@Component({
  selector: 'sidebar',
  exportAs: 'sidebar',
  host: {
    '[class]': 'computedClass()',
  },
  template: `<ng-content />`,
})
export class Sidebar {
  // Inputs / Outputs
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  // State
  protected readonly computedClass = computed(() =>
    bui(
      // Base
      'group/sidebar',
      'flex flex-col',
      'w-full',

      // User classes
      this.userClass(),
    ),
  );
}

@Component({
  selector: 'sidebar-header',
  exportAs: 'sidebarHeader',
  host: {
    '[class]': 'computedClass()',
  },
  template: `<ng-content />`,
})
export class SidebarHeader {
  // Inputs / Outputs
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  // State
  protected readonly computedClass = computed(() =>
    bui(
      // Base
      'group/sidebar-header',
      'p-6',

      // User classes
      this.userClass(),
    ),
  );
}

@Component({
  selector: 'sidebar-body',
  exportAs: 'sidebarBody',
  host: {
    '[class]': 'computedClass()',
  },
  template: `<ng-content />`,
})
export class SidebarBody {
  // Inputs / Outputs
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  // State
  protected readonly computedClass = computed(() =>
    bui(
      // Base
      'group/sidebar-body',
      'flex flex-auto flex-col overflow-auto',
      'gap-y-4 p-2 min-h-0',

      // User classes
      this.userClass(),
    ),
  );
}

@Component({
  selector: 'sidebar-footer',
  exportAs: 'sidebarFooter',
  host: {
    '[class]': 'computedClass()',
  },
  template: `<ng-content />`,
})
export class SidebarFooter {
  // Inputs / Outputs
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  // State
  protected readonly computedClass = computed(() =>
    bui(
      // Base
      'group/sidebar-footer',
      'p-3',

      // User classes
      this.userClass(),
    ),
  );
}
